export const ACCOUNTING_PERIOD_OPTIONS = [
  { value: 'tutti', label: 'Tutti i periodi' },
  { value: 'scaduti', label: 'Scaduti' },
  { value: 'prossimi_30', label: 'Prossimi 30 giorni' },
];

export const PAYMENT_STATUS_OPTIONS = [
  { value: 'tutti', label: 'Tutti gli stati' },
  { value: 'previsto', label: 'Previsto' },
  { value: 'incassato', label: 'Incassato' },
  { value: 'in_ritardo', label: 'In Ritardo' },
  { value: 'stornato', label: 'Stornato' },
  { value: 'annullato', label: 'Annullato' },
];

export const PAYMENT_TYPE_FILTER_OPTIONS = [
  { value: 'tutti', label: 'Tutte le tipologie' },
  { value: 'unico', label: 'Unico' },
  { value: 'rateizzato', label: 'Rateizzato' },
];

export const EXPENSE_STATUS_OPTIONS = [
  { value: 'tutti', label: 'Tutti gli stati' },
  { value: 'previsto', label: 'Previsto' },
  { value: 'da_saldare', label: 'Da Saldare' },
  { value: 'pagato', label: 'Pagato' },
  { value: 'in_ritardo', label: 'In Ritardo' },
];

export const EXPENSE_TYPE_OPTIONS = [
  { value: 'tutti', label: 'Tutti i tipi' },
  { value: 'stipendio', label: 'Stipendi' },
  { value: 'gestione', label: 'Gestione' },
  { value: 'spesa_aziendale', label: 'Spese Aziendali' },
  { value: 'pagamento', label: 'Pagamenti Fornitori' },
];

export const EXPENSE_TYPE_FORM_OPTIONS = [
  { value: 'stipendio', label: 'Stipendio' },
  { value: 'gestione', label: 'Gestione' },
  { value: 'spesa_aziendale', label: 'Spesa Aziendale' },
  { value: 'pagamento', label: 'Pagamento Fornitore' },
];

export const RECURRING_OPTIONS = [
  { value: 'una_tantum', label: 'Una Tantum' },
  { value: 'mensile', label: 'Mensile' },
  { value: 'trimestrale', label: 'Trimestrale' },
  { value: 'annuale', label: 'Annuale' },
];

export const EXPENSE_RECIPIENT_TYPE_OPTIONS = [
  { value: 'OTHER', label: 'Altro' },
  { value: 'STAFF', label: 'Staff' },
  { value: 'SUPPLIER', label: 'Fornitore' },
];

export const EXPENSE_RECIPIENT_FILTER_OPTIONS = [
  { value: 'tutti', label: 'Tutti i destinatari' },
  { value: 'staff', label: 'Staff' },
  { value: 'fornitori', label: 'Fornitori' },
  { value: 'altro', label: 'Altro' },
];

export const INVOICE_PAYMENT_TYPE_OPTIONS = [
  { value: 'unico', label: 'Pagamento Unico' },
  { value: 'rateizzato', label: 'Pagamento Rateizzato' },
];

function getDateOffsetIso(days) {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date.toISOString().split('T')[0];
}

export function getInitialInvoiceForm() {
  const issueDate = new Date().toISOString().split('T')[0];
  return {
    invoiceNumber: '',
    client: '',
    clientId: null,
    assignment: '',
    assignmentId: null,
    completedDealId: null,
    initialPaymentStatus: '',
    paymentExpectedDate: getDateOffsetIso(30),
    installmentCount: 1,
    installmentDueDates: [],
    inheritedPaymentPlan: false,
    type: 'unico',
    totalAmount: '',
    issueDate,
    notes: '',
    customFields: {},
  };
}

export function getInitialInvoiceInstallments() {
  return [{ amount: '', dueDate: '' }];
}

export function getInitialExpenseForm() {
  return {
    description: '',
    type: 'spesa_aziendale',
    amount: '',
    dueDate: new Date().toISOString().split('T')[0],
    recurring: 'una_tantum',
    recipientType: 'OTHER',
    staffId: '',
    supplierId: '',
    supplierName: '',
    notes: '',
    customFields: {},
  };
}
